export const toVirtualBackgroundImageUrl = (url: string): string =>
  url.startsWith('http://') || url.startsWith('https://') ? url : `/v2${url}`;
